import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[questionnaireHost]',
    standalone: false
})
export class QuestionnaireHostDirective {
  viewContainerRef = inject(ViewContainerRef);
}
